<input type="text"
       #input
       tabindex="0"
       [formControl]="formGroup.controls['cell']"
       class="ag-cell-edit-input wep-ag-grid-cell-editor-input__text"
       (blur)="onBlur()"
       [readonly]="params.readonly">